import common from './ja/common'
import validation from './ja/validation'
import login from './ja/pages/login'
import cl102 from './ja/pages/cl102'
import cl203 from './ja/pages/cl203'
import notification from './ja/pages/notification'
import account from './ja/pages/account'
import createNew from './ja/pages/create_new'
import report from './ja/pages/report'
import breadcrumb from './ja/breadcrumb'
import forgotPassword from './ja/pages/forgotPassword'
import resetPassword from './ja/pages/resetPassword'
import termsOfService from './ja/pages/termsOfService'
import termsOfService202201 from './ja/pages/termsOfService202201'
import specifiedCommodityTransactionLaw from './ja/pages/specifiedCommodityTransactionLaw'
import cancelChargePlan from './ja/pages/cancelChargePlan'
import acceptInvite from './ja/pages/acceptInvite'
import constructionUser from './ja/pages/constructionUser'
import applicationDetails from './ja/pages/applicationDetails'
import customerInformation from './ja/pages/customerInformation'
import confirmationApplicationDetails from './ja/pages/confirmationApplicationDetails'
import projectList from './ja/pages/project/projectList'
import completionReport from './ja/pages/project/completionReport'
import updateInfo from './ja/pages/project/updateInfo'
import privacy from './ja/pages/privacy'
import terms from './ja/pages/terms'
import faq from './ja/pages/faq'
import inviteNewUserInput from './ja/pages/inviteNewUserInput'
import softBank from './ja/pages/softbank'
import accountRole from './ja/pages/accountRole'
import daikinCoverReport from './ja/pages/daikinCoverReport'

const lang = {
  common,
  validation,
  breadcrumb,
  pages: {
    createNew,
    login,
    cl102,
    notification,
    account,
    cl203,
    forgotPassword,
    resetPassword,
    termsOfService,
    termsOfService202201,
    specifiedCommodityTransactionLaw,
    report,
    cancelChargePlan,
    constructionUser,
    acceptInvite,
    applicationDetails,
    customerInformation,
    confirmationApplicationDetails,
    projectList,
    completionReport,
    updateInfo,
    privacy,
    terms,
    faq,
    inviteNewUserInput,
    softBank,
    accountRole,
    daikinCoverReport
  },
};

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja.js